import { SET_PATIENT_INFO, SET_IS_P9, SET_PATIENT_TYPE } from 'helpers/types';

const STORAGE_PATIENT_INFO = 'patientInfo';
const STORAGE_IS_P9 = 'isP9';
const STORAGE_PATIENT_TYPE = "patientType";

const storage = {
  patientInfo: sessionStorage.getItem(STORAGE_PATIENT_INFO),
  isP9: sessionStorage.getItem(STORAGE_IS_P9),
  patientType: sessionStorage.getItem(STORAGE_PATIENT_TYPE)
};

const INITIAL_STATE = {
  patientInfo: storage.patientInfo === null ? {} : JSON.parse(storage.patientInfo),
  isP9: storage.isP9 === 'true',
  patientType: storage.patientType === null ? {} : storage.patientType
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_PATIENT_INFO:
      sessionStorage.setItem(STORAGE_PATIENT_INFO, JSON.stringify(action.payload));
      return {
        ...state,
        patientInfo: action.payload,
      };
    case SET_IS_P9:
      sessionStorage.setItem(STORAGE_IS_P9, action.payload);
      return {
        ...state,
        isP9: action.payload,
      };
    case SET_PATIENT_TYPE:
      sessionStorage.setItem(STORAGE_PATIENT_TYPE, action.payload);
      return {
        ...state,
        patientType: action.payload
      }
    default:
      return state;
  }
}
